const CPA_LEVEL_OPTIONS = [
   {
      value: 'Org',
      label: 'Organization',
   },
   {
      value: 'Adv',
      label: 'Hiring Company',
   },
   {
      value: 'Jg',
      label: 'Job Group',
   },
];

export default CPA_LEVEL_OPTIONS;
